import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../App.css";
import { Navbar, Hero, Manifesto, Values, Stats, Services } from "./Sections";
import { Day, Gallery, Newsletter, FinalCTA } from "./Sections2";
import Footer from "./Footer";
import RegisterModal from "./RegisterModal";
import { subscribeNewsletter } from "../api";

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const [nlError, setNlError] = useState("");
  const [registerOpen, setRegisterOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
    }
  }, [location]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        }),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setNlError("");
    try {
      await subscribeNewsletter(email);
      setSubmitted(true);
    } catch (err) {
      setNlError("Something went wrong. Please try again.");
    }
  };

  const openRegister = (e) => { if (e) e.preventDefault(); setRegisterOpen(true); };

  return (
    <div className="App on-dark">
      <Navbar scrolled={scrolled} menuOpen={menuOpen} setMenuOpen={setMenuOpen} onRegister={openRegister} />
      <Hero onRegister={openRegister} />
      <Manifesto />
      <Values />
      <Stats />
      <Services />
      <Day />
      <Gallery onRegister={openRegister} />
      <Newsletter onSubmit={handleSubmit} submitted={submitted} email={email} setEmail={setEmail} error={nlError} />
      <FinalCTA onRegister={openRegister} />
      <Footer />
      <RegisterModal open={registerOpen} onClose={() => setRegisterOpen(false)} />
    </div>
  );
}
